import { useEffect, useState } from "react";
import MandatorySign from "../../Components/MandatorySign";

const InputNote = ({
    handleClose,
    handleSelect,
    selectedItem,
    selectedNode
}) => {
    const [note, setNote] = useState("");

    const handleConfirm = () => {
        handleSelect(selectedItem.value, selectedItem, note);
    };

    useEffect(() => {
        if (!selectedNode) return;

        const existing = selectedNode?.data?.params;

        if (existing) {
          setNote(existing)
        }
    }, [selectedNode]);

    return (
        <>
            <div className="modal_main_cont">
                <div className="label_input">
                    <label className="input_label">
                        Add a note <MandatorySign message="Required" />
                    </label>

                    <textarea
                        className="register_form_first textarea_reg fade-in"
                        value={note}
                        placeholder="Add a note..."
                        onChange={(e) => setNote(e.target.value)}
                    />
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont" />

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleConfirm}
                        disabled={!note.trim()} 
                    >
                        Save note
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </>
    );
};

export default InputNote;